export interface ReferenceValidationRule {
	providerName: string;
	regex: RegExp;
	formatDescription: string;
	referenceLabel: string;
}

export const REFERENCE_VALIDATION_RULES: Record<string, ReferenceValidationRule> = {
	abp8sgsoh75mihbfhju9rumpw40hkpxu: {
		providerName: 'IATA UY',
		regex: /^[A-Z0-9]{6}$/,
		formatDescription: '6 caracteres alfanuméricos en mayúsculas (ej: BRUW99, BW6JG4)',
		referenceLabel: 'PNR',
	},
	'97f3f3f1-2430-48c7-b385-0a0ac2e9d87c': {
		providerName: 'World 2 Meet',
		regex: /^[A-Z0-9]{6}$/,
		formatDescription: '6 caracteres alfanuméricos en mayúsculas (ej: N15NW2, VMK224)',
		referenceLabel: 'Localizador',
	},
	'7cq4a5rlv0pu6xm2y2xztbwkxh0qqi5p': {
		providerName: 'Sevens PY Aéreos',
		regex: /^[A-Z0-9]{6}$/,
		formatDescription: '6 caracteres alfanuméricos en mayúsculas (ej: BWGB87, DNMABX)',
		referenceLabel: 'PNR',
	},
	'3xzylognx1tk7x0xqtecyi92diqiv5p0': {
		providerName: 'IATA PY',
		regex: /^[A-Z0-9]{6}$/,
		formatDescription: '6 caracteres alfanuméricos en mayúsculas (ej: BFTXVR, BW2J6E)',
		referenceLabel: 'PNR',
	},
	'677b018f-d337-405b-b22e-411ac2dbb53d': {
		providerName: 'GLOBAL - MERCADO DEL TURISMO',
		regex: /^[A-Z0-9]{6,7}$/,
		formatDescription: '6 a 7 caracteres alfanuméricos en mayúsculas (ej: AAHFPRD, BVB7QU)',
		referenceLabel: 'PNR',
	},
	'b7501922-9ac0-4efb-b0e7-5f49c2cc415e': {
		providerName: 'Journeys',
		regex: /^\d{6}$/,
		formatDescription: '6 dígitos numéricos (ej: 207728, 207444)',
		referenceLabel: 'Referencia',
	},
	'1f129439-e49a-4707-a9b0-3cb9c2cc53dd': {
		providerName: 'Nexus Tour',
		regex: /^[A-Z0-9]{6}$/,
		formatDescription: '6 caracteres alfanuméricos en mayúsculas (ej: SS9B2S, S2S6KR)',
		referenceLabel: 'Referencia',
	},
	'5663cb81-270c-465f-8a0c-322dc2ccd35f': {
		providerName: 'H&D Brasil',
		regex: /^\d{13}$/,
		formatDescription: '13 dígitos numéricos (ej: 1782494907389)',
		referenceLabel: 'Referencia',
	},
	'4e664526-bc45-4f98-ab1c-da62c2cd3141': {
		providerName: 'Tarjeta Celeste',
		regex: /^V\d{7}TC-[A-Z]{2}$/,
		formatDescription: 'V + 7 dígitos + TC- + 2 letras de país (ej: V1821878TC-UY)',
		referenceLabel: 'Localizador',
	},
	'9922f1af-35c3-4e7c-b404-fe5dc2e96f28': {
		providerName: 'Itaparica Tour',
		regex: /^[A-Z0-9]{6}$/,
		formatDescription: '6 caracteres alfanuméricos en mayúsculas (ej: TN7RQQ, Y5Y247)',
		referenceLabel: 'Localizador',
	},
	'8de1ad78-2878-482b-9758-641fc2cbe28d': {
		providerName: 'Welcome Beds',
		regex: /^\d{9}$/,
		formatDescription: '9 dígitos numéricos (ej: 802993048, 802950707)',
		referenceLabel: 'Localizador',
	},
	c322ecw2q2i32zehgu25hpc9m4wj1om1: {
		providerName: 'CIVITATIS',
		regex: /^[AT]\d{7,8}$/,
		formatDescription: 'Letra A o T seguida de 7 u 8 dígitos (ej: A39727184, T39613821)',
		referenceLabel: 'Referencia',
	},
	kj55oqvx4ryow2pdsskyo3cn2hq464uv: {
		providerName: 'PRICE TRAVEL',
		regex: /^\d{6,9}$/,
		formatDescription: '6 a 9 dígitos numéricos (ej: 135656510, 26015405)',
		referenceLabel: 'Localizador',
	},
	'8udp20uzn3pb1p81duzkcfpuofjc4dqv': {
		providerName: 'COPA',
		regex: /^[A-Z0-9]{6}$/,
		formatDescription: '6 caracteres alfanuméricos en mayúsculas (ej: DQ84X6, DM3NN1)',
		referenceLabel: 'PNR',
	},
	'9zyie8r63xdc2fagak1rm22udooyk6c9': {
		providerName: 'BOLIVIA BOOKING',
		regex: /^[A-Z0-9]{6}$/,
		formatDescription: '6 caracteres alfanuméricos en mayúsculas (ej: BCMDF3, CYKSYG)',
		referenceLabel: 'PNR',
	},
	gsrn782tp9zlnlk1u08klm8f3s2efbkh: {
		providerName: 'MY GLOBAL ASSIST',
		regex: /^MG[0-9A-F]{8}$/,
		formatDescription: 'MG seguido de 8 caracteres hexadecimales en mayúsculas (ej: MG23FB1C15)',
		referenceLabel: 'Localizador',
	},
	'9595c768-e359-44b6-bc47-604fc2b2719e': {
		providerName: 'Sevens UY Aéreos',
		regex: /^[A-Z0-9]{6}$/,
		formatDescription: '6 caracteres alfanuméricos en mayúsculas (ej: BUBZDB, BVBG46)',
		referenceLabel: 'PNR',
	},
	'38a05iwe1s8raqaoso6c96kiwltogd22': {
		providerName: 'Sevens UY Servicios',
		regex: /^(PH_[A-Z0-9]{5}(-\d+)?|\d{5,8})$/,
		formatDescription:
			'PH_ + 5 alfanuméricos opcionalmente seguido de -N, o entre 5 y 8 dígitos (ej: PH_32TW6-1, PH_32U4V-1)',
		referenceLabel: 'Localizador',
	},
	'64ea648e-58b2-4c67-bc8b-d82ec2bebf4a': {
		providerName: 'Hotelbeds',
		regex: /^\d{2,3}-\d{7}$/,
		formatDescription: '2 o 3 dígitos + guión + 7 dígitos (ej: 258-7484761, 249-3480519)',
		referenceLabel: 'Localizador',
	},
	'e65859ab-30aa-4e44-b45d-4044c2ccbc44': {
		providerName: 'Buquebus',
		regex: /^B\d{10}$/,
		formatDescription: 'Letra B seguida de 10 dígitos (ej: B2601461625)',
		referenceLabel: 'Localizador',
	},
	ihog6qqxp15encv2z9slmevsfnbenly1: {
		providerName: 'Liberty',
		regex: /^(PH_[A-Z0-9]{5}(-\d+)?|\d{5,8})$/,
		formatDescription:
			'PH_ + 5 alfanuméricos opcionalmente seguido de -N, o entre 5 y 8 dígitos (ej: PH_32SQC, 9564717)',
		referenceLabel: 'Localizador',
	},
	'15eddd09-c97b-4083-8c67-785bc2cf023c': {
		providerName: 'Amv Travel',
		regex: /^AM-\d{10}-\d{2}$/,
		formatDescription: 'AM- + 10 dígitos + - + 2 dígitos (ej: AM-0000031015-01)',
		referenceLabel: 'Referencia',
	},
	'6xi4c1epau98v6ffspirxp1pchtwkvi2': {
		providerName: 'TRAVELLER VIAJES',
		regex: /^URU[0-9A-F]{12}$/,
		formatDescription: 'URU seguido de 12 caracteres hexadecimales en mayúsculas (ej: URU2606306F271E)',
		referenceLabel: 'Localizador',
	},
	'8l3nh1rsfn4s5udyeqi2h2ui0493bcmu': {
		providerName: 'JETSMART',
		regex: /^[A-Z0-9]{6}$/,
		formatDescription: '6 caracteres alfanuméricos en mayúsculas (ej: BCIQYD, BFMGVI)',
		referenceLabel: 'PNR',
	},
	u1bibepazked3eyror9h1qkbw7ym44fw: {
		providerName: 'Mayl Tours',
		regex: /^[A-Z0-9]{6}$/,
		formatDescription: '6 caracteres alfanuméricos en mayúsculas (ej: CU4Q7O, BAMSHE)',
		referenceLabel: 'PNR',
	},
	'89de3b05-b6dc-430e-9d84-facfc2cc5f20': {
		providerName: 'Universal Assistance',
		regex: /^T\d{9}$/,
		formatDescription: 'Letra T seguida de 9 dígitos (ej: T033817305)',
		referenceLabel: 'Localizador',
	},
	jxhuhdr12wx4t51vl77fei9u2wgt1md5: {
		providerName: 'AEROMUNDO AEREOS',
		regex: /^[A-Z0-9]{6}$/,
		formatDescription: '6 caracteres alfanuméricos en mayúsculas (ej: A2RWAK, BIX2PJ)',
		referenceLabel: 'PNR',
	},
	isc9g86m3zh44hryx771co0t9ashfgac: {
		providerName: 'AVIANCA',
		regex: /^[A-Z0-9]{6}$/,
		formatDescription: '6 caracteres alfanuméricos en mayúsculas (ej: B3INSU, QGLIKV)',
		referenceLabel: 'PNR',
	},
	xh4cg21olsn4d33wkm7rg22zeexbsmu9: {
		providerName: 'I Need Tours',
		regex: /^[A-Z0-9]{6}$/,
		formatDescription: '6 caracteres alfanuméricos en mayúsculas (ej: Y1UO37, K3F1L9)',
		referenceLabel: 'Referencia',
	},
	pcgl4m07crxo7j9o3ux4xgv7heeabr0v: {
		providerName: 'Boliviana de Aviación BOA',
		regex: /^[A-Z0-9]{6}$/,
		formatDescription: '6 caracteres alfanuméricos en mayúsculas (ej: BHGSSX, HQVVIF)',
		referenceLabel: 'PNR',
	},
	qpilsa7fa9kd33fjmnp5q9y1092qz880: {
		providerName: 'AMERICAN AIRLINES',
		regex: /^[A-Z0-9]{6}$/,
		formatDescription: '6 caracteres alfanuméricos en mayúsculas (ej: OHYMUS, QEKJZL)',
		referenceLabel: 'PNR',
	},
	de5m0jyv5b4w688qyxsk5nyaz37e5db4: {
		providerName: 'WINGO',
		regex: /^[A-Z0-9]{6}$/,
		formatDescription: '6 caracteres alfanuméricos en mayúsculas (ej: VZCC2U, HXKQNS)',
		referenceLabel: 'PNR',
	},
	'6cgvhkbr8i9b26hxagz0dchucjbz1b70': {
		providerName: 'AEROLINEAS ARGENTINAS',
		regex: /^[A-Z0-9]{6}$/,
		formatDescription: '6 caracteres alfanuméricos en mayúsculas (ej: AGMOGJ, ASMRMV)',
		referenceLabel: 'PNR',
	},
	uw10xaxo163cezkfe7prg7lf9sf44c6x: {
		providerName: 'VIVA AEROBUS',
		regex: /^[A-Z0-9]{6}$/,
		formatDescription: '6 caracteres alfanuméricos en mayúsculas (ej: URHJGT, XY2CGI)',
		referenceLabel: 'PNR',
	},
	kjkoecrhb3qca4tmxtw6ku42ey45d84y: {
		providerName: 'UNITED AIRLINES',
		regex: /^[A-Z0-9]{6}$/,
		formatDescription: '6 caracteres alfanuméricos en mayúsculas (ej: P07SSK, BCDOOA)',
		referenceLabel: 'PNR',
	},
};

/**
 * Valida el valor de referencia contra la regla del proveedor.
 * Retorna null si el proveedor no tiene regla configurada, o si la referencia está vacía/es el placeholder '-'.
 * Retorna { valid, rule } si hay regla para ese proveedor.
 */
export const validateReference = (
	providerId: string,
	reference: string,
): { valid: boolean; rule: ReferenceValidationRule } | null => {
	const rule = REFERENCE_VALIDATION_RULES[providerId];
	if (!rule) return null;
	if (!reference || reference === '-' || reference.trim() === '') return null;
	return { valid: rule.regex.test(reference.trim()), rule };
};
